import { Text } from '@react-pdf/renderer'
import { useTranslation } from 'react-i18next'

import { pdfPageCounterStyles } from './utils/pdfPageCounterStyles'

export const PdfPageCounter = () => {
  const { t } = useTranslation()

  return (
    <Text
      style={pdfPageCounterStyles.pageCounterText}
      render={({ pageNumber, totalPages }) => <>{t('pdf.page_counter', { page: pageNumber, total: totalPages })}</>}
      fixed={true}
    />
  )
}
